import { useSessionStorage } from '@sorare/core/src/hooks/useSessionStorage';

export const useComposeTeamAutosave = (
  so5LeaderboardSlug: string,
  composeSessionId: string
) => {
  const [composeTeam, setComposeTeam] = useSessionStorage(
    'composeTeamSelection'
  );
  const getSessionData = () => {
    if (composeTeam?.so5LeaderboardSlug !== so5LeaderboardSlug) {
      return {
        so5LeaderboardSlug,
        composeSessionId,
        benchObjectIds: [],
      };
    }
    return {
      ...composeTeam,
      benchObjectIds: [...(composeTeam?.benchObjectIds || [])],
    };
  };

  const addItemToAutosave = (position: number, benchObjectId: string) => {
    const newData = getSessionData();
    newData.benchObjectIds[position] = benchObjectId;
    setComposeTeam(newData);
  };
  const removeItemFromAutosave = (position: number) => {
    const newData = getSessionData();
    newData.benchObjectIds[position] = null;
    setComposeTeam(newData);
  };
  const addItemsToAutoSave = (
    items: { position: number; benchObjectId: string }[]
  ) => {
    const newData = getSessionData();
    items.forEach(({ position, benchObjectId }) => {
      newData.benchObjectIds[position] = benchObjectId;
    });

    setComposeTeam(newData);
  };

  const clearAutosave = () => {
    setComposeTeam(null);
  };

  return {
    addItemToAutosave,
    addItemsToAutoSave,
    removeItemFromAutosave,
    clearAutosave,
  };
};
